import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { toast } from "react-toastify";

const CopyableValue = ({ value, monospace = false }) => {
  if (value == null || value === "") {
    return <Typography variant="body2">—</Typography>;
  }

  const text = String(value);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("کپی شد.");
    } catch {
      toast.error("کپی ناموفق بود.");
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={0.5}>
      <Typography
        variant="body2"
        sx={{
          wordBreak: "break-all",
          fontFamily: monospace ? "monospace" : undefined,
        }}
      >
        {text}
      </Typography>
      <Tooltip title="کپی">
        <IconButton size="small" onClick={handleCopy}>
          <ContentCopyIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default CopyableValue;
